import script from "./ProgramFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramFilters.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramFilters.vue?vue&type=style&index=0&id=1955dabb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1955dabb"]])

export default __exports__